import { AnalyticsContext } from '@bridebook/analytics';

export class AnalyticsService extends AnalyticsContext {}
